import { getStorage } from './storage';
const cache = {
    sysTimestamp: null,
    localTimestamp: null,
};
const storage = getStorage('__api', 'session');
export async function getSystime() {
    function getSysTime() {
        return new Promise((resolve) => {
            fetch('/promotion/v1/play/serverTime', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((res) => {
                    if (!res.ok) {
                        resolve(0);
                    } else {
                        res.json().then((r) => {
                            resolve(+r.data.timeStamp);
                        });
                    }
                })
                .catch(() => resolve(0));
        });
    }
    function getCurTime() {
        return Math.floor(Date.now() / 1000);
    }
    if (!cache.sysTimestamp) {
        cache.sysTimestamp = storage.get('sysTimestamp');
        cache.localTimestamp = storage.get('localTimestamp');
        if (!cache.sysTimestamp) {
            const sysTimestamp = await getSysTime();
            const localTimestamp = getCurTime();
            storage.set({ sysTimestamp, localTimestamp });
            Object.assign(cache, { sysTimestamp, localTimestamp });
        }
    }
    const { sysTimestamp, localTimestamp } = cache;
    const curTime = getCurTime();
    return sysTimestamp + curTime - localTimestamp;
}


// WEBPACK FOOTER //
// ./src/utils/getSystime.js